import { styled } from "styled-components";
import theme from "../../styles/theme";
import { ResponsiveBar } from "@nivo/bar";
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const MainWrap = styled.div`
    height: 100%;
    width: 100%;
    background: ${theme.color.white[100]};
    border-radius: 12px;
    padding: 0.5rem 1rem;
    .title_line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            font-size: 1.25rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
        }
    }
`;

const BarStyle = styled.div`
    margin: 6px 0px;
    width: calc(30% + ${(props)=>props.size ? props.size : '0'}%);
    min-width: 30%;
    max-width: 100%;
    height: 2rem;
    background: rgb(${(props)=>props.size ? 260-(props.size/20) : '255'}, ${(props)=>props.size ? 133+props.size : '0'}, ${(props)=>props.size ? 153+props.size : '0'});
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
        display: inline-block;
        margin:0;
        padding-left: 8px;
        font-size: 0.9rem;
        height: 1.2rem;
        // line-height: 1.2rem;
        // overflow: hidden;
        white-space: nowrap;
    }
    transition: all 1000ms ease-in-out, transform 1000ms ease-in-out;
`;

const SampleData = [
    // { title:'7번조사', complete:100 },
    // { title:'6번kgkgkgkgkgkgkggk조사', complete:8 },
    { title:'5번조사', complete:100 },
    { title:'4번조사ddddddddddddddddddddd', complete:2 },
    { title:'3번조사', complete:30 },
    { title:'2번조사', complete:6 },
    { title:'1번조사', complete:60 },
]
const CodingStatus = () => {

    return (
        <MainWrap>
            <div className="title_line"><span><VideoSettingsIcon />코딩 진행상황</span><MoreVertIcon /></div>
            <div style={{width:'100%',maxWidth:'100%',height:'calc(100% - 3rem)'}}>
            {SampleData && SampleData.map((item,index)=>
                <BarStyle size={item.complete}>
                    <span>{item.title} : {item.complete}%</span>
                </BarStyle>
            )}
            </div>
            {/* <ResponsiveBar
                    theme={{fontSize: '0.8rem'}}
                    data={SampleData}
                    keys={[
                        'complete',
                    ]}
                    indexBy="title"
                    margin={{ top: 0, right: 0, bottom: 0, left: 80 }}
                    padding={0.2}
                    innerPadding={3}
                    layout="horizontal"
                    valueScale={{ type: 'symlog' }}
                    indexScale={{ type: 'band', round: true }}
                    colorBy="indexValue"
                    // colors={[theme.color.secondary.puppleB]}
                    borderColor={{ theme: 'background' }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={null}
                    axisLeft={{
                        tickSize: 0,
                        tickPadding: 0,
                        tickRotation: 0,
                        // legendOffset: 40
                    }}
                    // minValue={0}
                    // maxValue={100}
                    enableGridY={false}
                    label={d=>`${d.value}%`}
                    // labelSkipWidth={12}
                    // labelSkipHeight={12}
                    labelTextColor={'#333333'}
                    tooltip={()=>{return false}}
                /> */}
        </MainWrap>
    )
}

export default CodingStatus;
